function initBeginBuyBoxGallery(section) {
  const gallery = section.querySelector('[data-buy-box-gallery]');
  if (!gallery) return;

  const thumbs = gallery.querySelectorAll('[data-buy-box-thumb]');
  const mainImg = section.querySelector('[data-buy-box-main-img]');
  const thumbList = gallery.querySelector('[data-buy-box-thumbs]');
  const prevBtn = gallery.querySelector('[data-buy-box-gallery-prev]');
  const nextBtn = gallery.querySelector('[data-buy-box-gallery-next]');

  thumbs.forEach((thumb) => {
    thumb.addEventListener('click', () => {
      const fullSrc = thumb.getAttribute('data-full-src');
      if (mainImg && fullSrc) mainImg.src = fullSrc;

      thumbs.forEach((t) => {
        t.classList.remove('begin-buy-box__thumb--active');
        t.setAttribute('aria-pressed', 'false');
      });
      thumb.classList.add('begin-buy-box__thumb--active');
      thumb.setAttribute('aria-pressed', 'true');
    });
  });

  if (thumbList && (prevBtn || nextBtn)) {
    const updateGalleryNavState = () => {
      const maxScroll = thumbList.scrollHeight - thumbList.clientHeight;
      if (prevBtn) prevBtn.disabled = thumbList.scrollTop <= 0;
      if (nextBtn) nextBtn.disabled = thumbList.scrollTop >= maxScroll - 1;
    };

    thumbList.addEventListener('scroll', updateGalleryNavState);
    window.addEventListener('resize', updateGalleryNavState);
    updateGalleryNavState();
  }

  if (prevBtn && thumbList) {
    prevBtn.addEventListener('click', () => {
      thumbList.scrollBy({ top: -80, behavior: 'smooth' });
    });
  }

  if (nextBtn && thumbList) {
    nextBtn.addEventListener('click', () => {
      thumbList.scrollBy({ top: 80, behavior: 'smooth' });
    });
  }
}

function initBeginBuyBoxDosage(section) {
  const closeButtons = section.querySelectorAll('[data-buy-box-dosage-close]');
  const reopenButtons = section.querySelectorAll('[data-buy-box-dosage-reopen]');

  closeButtons.forEach((button) => {
    button.addEventListener('click', () => {
      section.classList.add('is-dosage-hidden');
    });
  });

  reopenButtons.forEach((button) => {
    button.addEventListener('click', () => {
      section.classList.remove('is-dosage-hidden');
    });
  });
}

function initBeginBuyBoxPurchase(section) {
  const buyBox = section.querySelector('[data-buy-box]');
  if (!buyBox) return;

  const form = section.querySelector('.begin-buy-box__form');
  const idInput = form ? form.querySelector('input[name="id"]') : null;
  const buyOnceBtn = buyBox.querySelector('[data-buy-box-buy-once]');
  const submitBtn = buyBox.querySelector('[data-buy-box-submit]');

  function addToCart(variantId, sellingPlanId, busyEl) {
    if (busyEl) busyEl.setAttribute('aria-busy', 'true');

    const body = {
      id: variantId,
      quantity: 1,
      sections: ['cart-drawer', 'cart-icon-bubble'],
      sections_url: window.location.pathname,
    };
    if (sellingPlanId) body.selling_plan = sellingPlanId;

    return fetch((window.routes && window.routes.cart_add_url) || '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
    })
      .then((res) => {
        if (!res.ok) return res.json().then((err) => Promise.reject(err));
        return res.json();
      })
      .then((response) => {
        if (response.sections) {
          const cartDrawer = document.querySelector('cart-drawer');
          if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
            cartDrawer.renderContents(response);
          }
        }

        return fetch('/cart.js', { headers: { 'Content-Type': 'application/json' } })
          .then((res) => res.json())
          .then((cart) => {
            document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart } }));

            document.querySelectorAll('[data-cart-count]').forEach((el) => {
              el.textContent = cart.item_count;
            });

            const drawerToggle = document.getElementById('cart-icon-bubble');
            if (drawerToggle) {
              const cartDrawer = document.querySelector('cart-drawer');
              if (cartDrawer && typeof cartDrawer.open === 'function') {
                cartDrawer.open(drawerToggle);
              }
            }
          });
      })
      .catch(() => {})
      .finally(() => {
        if (busyEl) busyEl.removeAttribute('aria-busy');
      });
  }

  // "Buy Once" is a quick-add shortcut, not a mode switch: it adds the
  // one-time variant (no selling_plan) straight to the cart and opens the
  // drawer, without touching anything else in the buy box's displayed state.
  if (buyOnceBtn && idInput) {
    buyOnceBtn.addEventListener('click', () => {
      addToCart(idInput.value, null, buyOnceBtn);
    });
  }

  if (form) {
    form.addEventListener('submit', (event) => {
      event.preventDefault();
      const formData = new FormData(form);
      addToCart(formData.get('id'), formData.get('selling_plan'), submitBtn);
    });
  }
}

function initBeginBuyBox() {
  document.querySelectorAll('.begin-buy-box').forEach((section) => {
    initBeginBuyBoxGallery(section);
    initBeginBuyBoxPurchase(section);
    initBeginBuyBoxDosage(section);
  });
}

document.readyState !== 'loading' ? initBeginBuyBox() : document.addEventListener('DOMContentLoaded', initBeginBuyBox);
